<template>
	<table class="table-assign">
		<thead
			class="table-assign-header"
			:class="{ 'blue-table': blue, combination }"
			:style="`color:${$appColors.secondary};color:${blue ? $appColors.primary : $appColors.info}`"
		>
			<tr>
				<th 
					v-for="col in columns" 
					:key="col.id"
					:colspan="col.col"
					:style="`border-bottom:1px solid ${$appColors.gray};`"
				>
					{{col.name}}
				</th>
			</tr>
		</thead>
		<tbody class="table-assign-body" :class="{ 'combination': combination && rows.length }">
			<template v-if="rows.length">
				<tr v-for="row in rows"
					:key="row.id"
					:class="{ 'blue-table': blue }"
				>
					<td
						v-if="viewRadio"
						class="td-check"
					>
						<v-radio-group 
							v-model="radio" 
							height="0"
							>
							<v-radio 
								:value="row.id"
								color="success"
								@change="changeRadio">
							</v-radio>
						</v-radio-group>
					</td>
					<slot name="rows" :row="row"></slot>
				</tr>
			</template>
			<tr v-else>
				<td :colspan="columns.length">No hay infomación que mostrar</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
function changeRadio(value) {
	this.$emit('change-radio', value);
}

function data() {
	return {
		radio: null,
	};
}

export default {
	name: 'assign-area',
	data,
	methods: {
		changeRadio,
	},
	props: {
		rows: {
			type: Array,
			default: () => [],
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		viewRadio: {
			type: Boolean,
			default: false,
		},
		blue: {
			type: Boolean,
			default: false,
		},
		combination: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.table-assign {
		border: 0px;
		width: 100%;

		&-header {
			background: color(gray-white);

			th {
				padding: 10px;

				&:first-child {
					font-size: 18px;
					padding-left: 63px;
					text-align: left;
				}
			}

			&.blue-table {
				font-size: map-get($sizes, small);

				th {
					font-weight: 100 !important;
					text-align: left;
					
					&:first-child {
						font-size: map-get($sizes, small);
						padding-left: 56px;
					}
				}
			}

			&.combination {
				th {
					&:nth-child(2) {
						color: map-get($colors, primary);
						font-size: 19px;
					}
				}
			}
		}

		&-body {
			background: map-get($colors, white);

			tr {
				td:nth-child(2) {
					border-right: 1px solid map-get($colors, gray-slider);
					font-size: 12px;
					text-align: left;
				}

				td {
					font-size: 16px;
					text-align: center;
				}

				&.blue-table {
					td:nth-child(2) {
						border-right: none;
						font-size: 12px;
					}

					td {
						font-size: 12px;
						padding: 10px 0 10px 10px;
						text-align: left;

						&:first-child {
							padding-left: 56px;
						}
					}
				}
			}

			&.combination {
				tr {
					td:first-child {
						border-right: 1px solid map-get($colors, gray-slider);
						font-size: map-get($sizes, small);
						padding-left: 27px;
						text-align: left;
					}

					td:nth-child(2) {
						font-size: map-get($sizes, large);
						text-align: center;
					}
				}
			}
		}

		.td-check {
			width: 34px;
		}

		tr {
			border: 1px solid map-get($colors, gray-slider);
		}

		td {
			padding: 0 10px;
		}

		.v-radio {
			margin-right: 0px !important;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/configuration/assign-area.vue